import styled from '@emotion/styled'

export const CategoryInputLabel = styled.label`
  color: #3c4043;
  display: block;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  letter-spacing: 0.25px;
  line-height: 35px;
  opacity: 1;
  text-decoration: none;
  text-transform: none;
`

export const CategoryCancelButton = styled.button`
  -webkit-border-radius: 4px;
  -webkit-box-sizing: border-box;
  background-color: transparent;
  background-position: center;
  border: 1px solid #dadce0;
  border-radius: 4px;
  box-sizing: border-box;
  height: 36px;
  padding: 8px;
  transition: background 0.8s;
  margin-left: 0.7rem;

  &:hover {
    background: #f1f3f4 radial-gradient(circle, transparent 1%, #f1f3f4 1%)
      center/15000%;
    cursor: pointer;
  }

  &:active {
    background-color: #d4d6d7;
    background-size: 100%;
    transition: background 0s;
  }
`

export const CategoryAddButton = styled.button`
  -webkit-border-radius: 4px;
  -webkit-box-sizing: border-box;
  background-color: rgba(0, 92, 217, 0.14);

  background-position: center;
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
  height: 36px;
  margin-left: 8px;
  padding: 8px;

  transition: background 0.8s;
  width: 59.5px;

  &:hover {
    background: rgba(0, 92, 217, 0.2)
      radial-gradient(circle, transparent 1%, rgba(0, 92, 217, 0.2) 1%)
      center/15000%;
    cursor: pointer;
  }

  &:active {
    background-color: rgba(0, 92, 217, 0.3);
  }

  &:focus {
    background-color: rgba(0, 92, 217, 0.3);
    border-bottom: 2px solid #005cd9;
  }
`
